import { Injectable } from '@angular/core';
import { ZalacznikWiadomosciDto } from '@interfaces/komunikacja/komunikacja.interface';
import {
  EdytujWersjeRoboczaRequest,
  StworzWersjeRoboczaRequest,
  UsunWersjeRoboczaRequest,
  UzytkownikIGrupaOdbiorcowDto,
  UzytkownikIGrupaOdbiorcowDtoQueryParams,
  WiadomoscDto,
  WiadomoscDtoQueryParams,
} from '@interfaces/komunikacja/wersje-robocze.interface';
import { PageQueryParams } from '@interfaces/params.interface';
import { INewRecord, IPaginatedData } from '@interfaces/response.interface';
import { ApiBaseService } from '@services/api-base.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class WersjeRoboczeService extends ApiBaseService {
  private readonly endpoint = `${this.apiUrl}/komunikacja/wiadomosci/wersje-robocze`;

  saveDraft(body: StworzWersjeRoboczaRequest): Observable<INewRecord> {
    return this.http.post<INewRecord>(this.endpoint, body);
  }

  editDraft(draftId: string, data: EdytujWersjeRoboczaRequest): Observable<null> {
    return this.http.put<null>(`${this.endpoint}/${draftId}`, data);
  }

  setAttachment(draftId: string, data: FormData): Observable<null> {
    return this.http.post<null>(`${this.endpoint}/${draftId}/zalaczniki`, data);
  }

  getAttachments(draftId: string, params?: PageQueryParams): Observable<IPaginatedData<ZalacznikWiadomosciDto>> {
    return this.http.get<IPaginatedData<ZalacznikWiadomosciDto>>(`${this.endpoint}/${draftId}/zalaczniki`, {
      params: this.createQueryParams(params),
    });
  }

  downloadAttachment(draftId: string, attachmentId: string): Observable<ArrayBuffer> {
    return this.http.get<ArrayBuffer>(`${this.endpoint}/${draftId}/zalaczniki/${attachmentId}`, {
      responseType: 'arraybuffer' as 'json',
    });
  }

  sendMessage(draftId: string): Observable<null> {
    return this.http.patch<null>(`${this.endpoint}/${draftId}/wyslij`, null);
  }

  getRecords(queryParams?: WiadomoscDtoQueryParams): Observable<IPaginatedData<WiadomoscDto>> {
    return this.http.get<IPaginatedData<WiadomoscDto>>(this.endpoint, {
      params: this.createQueryParams(queryParams),
    });
  }

  getUzytkownicyIGrupyOdbiorcow(
    queryParams?: UzytkownikIGrupaOdbiorcowDtoQueryParams,
  ): Observable<IPaginatedData<UzytkownikIGrupaOdbiorcowDto>> {
    return this.http.get<IPaginatedData<UzytkownikIGrupaOdbiorcowDto>>(
      `${this.endpoint}/uzytkownicy-i-grupy-odbiorcow`,
      {
        params: this.createQueryParams(queryParams),
      },
    );
  }

  getRecord(id: string): Observable<WiadomoscDto> {
    return this.http.get<WiadomoscDto>(`${this.endpoint}/${id}`);
  }

  delete(body: UsunWersjeRoboczaRequest): Observable<null> {
    return this.http.delete<null>(`${this.endpoint}`, { body });
  }

  deleteAttachment(id: string, attachmentId: string): Observable<null> {
    return this.http.delete<null>(`${this.endpoint}/${id}/zalaczniki/${attachmentId}`);
  }
}
